import React from 'react';
import about from '../assests/img/about-home.jpeg';


import img1 from '../assests/img/Image-1.jpg';
import img2 from '../assests/img/Image-2.jpg';
import img3 from '../assests/img/Image-3.jpg';
import img4 from '../assests/img/Image-4.jpg';
import img5 from '../assests/img/Image-5.jpg';
import img6 from '../assests/img/Image-6.jpg';





function About() {
  return (
    <>
      <section className="home-about">
        <div className="container">
          <div className="row">
            <div className='about-img col-md-6'>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/7-CVaE_VU5A?si=6H6ZHxqOAeXMVcLM&amp;start=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div className='about-text col-md-6'>
              <h2>Jaipur Silver Show – India’s Premier Silver Jewellery Exhibition</h2>
              <p>Aadikaash International proudly presents the Jaipur Silver Show, India’s biggest and most prestigious B2B Silver Jewellery Exhibition. This grand Silver Show of India brings together leading manufacturers, designers, and wholesalers from across the country to showcase their finest craftsmanship and innovations in silver jewellery.</p>
              <p>With over a decade of expertise in curating successful B2B jewellery exhibitions, Aadikaash International continues to uphold its legacy of excellence and trust. The Silver Jewellery Show in Jaipur offers an exclusive platform for businesses to network, collaborate, and explore new opportunities in the ever-evolving silver market.</p>
<p>This remarkable event is not just a showcase — it’s a celebration of artistry, culture, and business growth. Whether you’re a retailer, wholesaler, or industry professional, the Jaipur Silver Show is your gateway to discovering new trends, strengthening partnerships, and expanding your business horizons.</p>
            </div>
          </div>
        </div>
      </section>
      
    </>
  )

}

export default About;
